import { useRef, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useMutation } from '@apollo/client';
import SpinnerOverlay from '../../../common/spinner/spinner';
import { AddIcon, CancelIcon } from '../../../common/icons';

import { notifySuccess } from '../../../../services/notification';
import { CREATE_POSITION_EMAIL, GET_POSITION_EMAILS } from '../../../../graphql/contact-gql';
import EmailDetails, { EmailHandler } from './email-detail';
import Button from '../../../common/button';

type DigitalAddressCreateProps = {
    positionId: number;
    isRole: boolean;
    isOpen: boolean;
    toggle: () => void
}

const EmailCreate = (props: DigitalAddressCreateProps) => {
    const {positionId, isRole, isOpen, toggle} = props

    const [createDigitalAddress, {loading}] = useMutation(CREATE_POSITION_EMAIL)
    const [validated, setValidated] = useState<boolean>(false)

    const digitalAddressRef = useRef<EmailHandler>(null)

    const onCreateDigitalAddress = () => {
        if (digitalAddressRef.current && !digitalAddressRef.current.validate(true)) {
            setValidated(false)
            return
        }
        let emailInput = digitalAddressRef.current && digitalAddressRef.current.getEmail()
        createDigitalAddress({
            variables: {
                positionId: positionId,
                input: emailInput
            },
            refetchQueries: [{
                query: GET_POSITION_EMAILS,
                variables: { positionId: positionId }
            }],
            awaitRefetchQueries: true,
            onCompleted: (data) => {
                toggle()
                data && notifySuccess()
            }
        })
    }

    const onChange = () => {
        setValidated(!!digitalAddressRef.current?.validate(false))
    }

    return (<>
        {loading && <SpinnerOverlay />}
        <Modal size="lg" isOpen={isOpen} toggle={toggle} scrollable backdrop="static" autoFocus={false}>
            <ModalHeader toggle={toggle} tag={'h2'}>Add a {isRole ? 'Role' : 'Position'} Email Address</ModalHeader>
            <ModalBody>
                <EmailDetails ref={digitalAddressRef} isRole={isRole} onChange={onChange} autoFocus={true}/>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={onCreateDigitalAddress} disabled={!validated}><AddIcon/> Add</Button>
                <Button color="secondary" onClick={toggle}><CancelIcon/> Cancel</Button>
            </ModalFooter>
        </Modal>
        </>
    )
}

export default EmailCreate
